import { useState } from "react";
import { TeamCreate } from "../../../types/team.types";
import { TeamForm } from "../../../components/team-form";
import { useNavigate } from "react-router-dom";
import { TeamsAPI } from "../../../APIs/teams.api";
import { useToast } from "../../../components/toast";

export function TeamAdd() {
  const [formData, setFormData] = useState<TeamCreate>({
    name: "",
    institution_id: 1,
  });
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { addToast } = useToast();
  function handleChange(e: React.ChangeEvent<HTMLElement>) {
    const { name, value } = e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await TeamsAPI.createTeam(formData);
      if (response.statusCode === 201) {
        addToast({
          message: "¡Equipo creado!",
          type: "success",
          location: "bottom-center",
        });
        navigate(`/dashboard/teams/view/${response.data.id}`);
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        message: "Error al crear el equipo, intente nuevamente",
        type: "error",
        location: "bottom-center",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleCancel = () => {
    navigate(-1);
  };
  return (
    <div className="min-h-screen mt-10">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
        <TeamForm
          createTeam={formData}
          title="Crear Equipo"
          buttonText="Crear"
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
}
